<template>
  <div class="v-data-table report bordered--table theme--light">
    <template v-for="item in list">
      <table class="report table table-bordered" v-if="type === 'all' || type === 'estimation'" :key="item.projectid">
        <tbody>
          <tr style="background: #354759!important; color: #fff;">
            <td colspan="8"><b>{{ $t('message.stamp.project') }}: {{ item.projectname || '' }}</b></td><!-- {{ item.projectnumber || '' }} -->
          </tr>
        </tbody>
        <tbody v-for="activity in item.activities" :key="activity.activityid">
          <tr style=" background: #5bc0de !important; color: #fff;">
            <td colspan="8"><b>{{ $t('message.stamp.activity') }}: {{ activity.activityname || '' }}</b></td>
          </tr>
          <tr>
            <td v-for="(head, index) in headers" :width="head.width" :key="index"><b>{{ head.text }}</b></td>
          </tr>
          <tr v-for="hour in activity.hours" :key="hour.id">
            <td v-for="(head, index) in headers" :key="index">
              <template v-if="head.name === 'date'">{{ hour[head.name] | dateFormat }}</template>
              <template v-else-if="head.name === 'hours'">{{ hour[head.name] | replaceDotWithComma }}</template>
              <template v-else>{{ hour[head.name] }}</template>
            </td>
          </tr>
          <tr style="background: rgb(255, 186, 192) !important;">
            <td colspan="8"><b>{{ $t('message.reports.total') }}: {{ $format.getSumBy(activity.hours, x => x.hours) | replaceDotWithComma }}</b></td>
          </tr>
          <tr style="background: rgba(168, 191, 197, 0.62) !important;" v-if="type === 'estimation'">
            <td colspan="4"><b>{{ $t('message.reports.estimation') }}: {{ activity.estimationhrs | replaceDotWithComma }}</b></td>
            <td colspan="4"><b>{{ $t('message.reports.progress') }}: {{ activity.progress || '0' | replaceDotWithComma }} %</b></td>
          </tr>
        </tbody>
        <tbody>
          <tr style="background: rgb(255, 186, 192) !important;">
            <td colspan="8"><b>{{ $t('message.reports.total')  }}: {{ getProjectTotal(item.activities) | replaceDotWithComma }}</b></td>
          </tr>
          <tr style="background: rgb(255, 186, 192) !important;" v-if="type === 'estimation'">
            <td colspan="2"><b>{{ $t('message.reports.estimation') }}: {{ getProjectEstimation(item.activities) }}</b></td>
            <td colspan="2"><b>{{ $t('message.reports.cost') }}: {{ item.cost || '0' | replaceDotWithComma }}</b></td>
            <td colspan="2"><b>{{ $t('message.reports.userCost') }}: {{ item.usercost || '0' | replaceDotWithComma }}</b></td>
            <td colspan="2"><b>{{ $t('message.reports.progress') }}: {{ getProjectProgress(item.activities) | replaceDotWithComma }} %</b></td>
          </tr>
        </tbody>
      </table>
    </template>
    <table class="report table table-bordered" v-if="type === 'sum'">
      <tbody v-for="item in list" :key="item.projectid">
        <tr style="background: #354759!important; color: #fff;">
          <td colspan="2"><b>{{ $t('message.stamp.project') }}: {{ item.projectname || '' }} </b></td><!-- {{ item.projectnumber || '' }} -->
        </tr>
        <tr>
          <td width="70%"><b>{{ $t('message.stamp.activity') }}</b></td>
          <td width="30%"><b>{{ $t('message.reports.total') }}</b></td>
        </tr>
        <tr v-for="activity in item.activities" :key="activity.activityid">
          <td>{{ activity.activityname }}</td>
          <td>{{ $format.getSumBy(activity.hours, x => x.hours) | replaceDotWithComma }}</td>
        </tr>
      </tbody>
    </table>
    <table class="report table table-bordered" v-if="type === 'sum_both'">
      <tbody v-for="item in list" :key="item.projectid">
        <tr style="background: #354759!important; color: #fff;">
          <td colspan="4"><b>{{ $t('message.stamp.project') }}: {{ item.projectname || '' }} </b></td><!-- {{ item.projectnumber || '' }} -->
        </tr>
        <tr>
          <td colspan="2"><b>{{ $t('message.reports.estimation') }}: {{ getProjectEstimation(item.activities) }} </b></td>
          <td colspan="2"><b>{{ $t('message.reports.progress') }}: {{ getProjectProgress(item.activities) | replaceDotWithComma }} % </b></td>
        </tr>
        <tr>
          <td width="20%"><b>{{ $t('message.stamp.activity') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.total') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.estimation') }}</b></td>
          <td width="20%"><b>{{ $t('message.reports.progress') }} %</b></td>
        </tr>
        <tr v-for="activity in item.activities" :key="activity.activityid">
          <td>{{ activity.activityname }}</td>
          <td>{{ $format.getSumBy(activity.hours, x => x.hours) | replaceDotWithComma }}</td>
          <td>{{ activity.estimationhrs | replaceDotWithComma }}</td>
          <td>{{ activity.progress || '0' | replaceDotWithComma }} %</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['type', 'list', 'headers'],
  methods: {
    getProjectTotal (allActivities) {
      let total = 0
      if (allActivities && allActivities.length > 0) {
        for (let i = 0; i < allActivities.length; i++) {
          total += this.$format.getSumBy(allActivities[i].hours, x => x.hours)
        }
      }
      return total
    },
    getProjectEstimation (allActivities) {
      let total = 0
      if (allActivities && allActivities.length > 0) {
        for (let i = 0; i < allActivities.length; i++) {
          total += allActivities[i].estimationhrs
        }
      }
      return total
    },
    getProjectCost (allActivities) {
      let total = 0
      if (allActivities && allActivities.length > 0) {
        allActivities.forEach(activity => {
          if (activity.hours && activity.hours.length > 0) {
            activity.hours.forEach(hour => {
              total += hour.project_cost
            })
          }
        })
      }
      return total
    },
    getProjectProgress (allActivities) {
      let total = 0
      if (allActivities && allActivities.length > 0) {
        for (let i = 0; i < allActivities.length; i++) {
          total += allActivities[i].progress
        }
      }
      return total
    }
  }
}
</script>
